const TAB_KEY = 'basicInfo'
export default {
  data () {
    return {
      basicInfoKey: TAB_KEY
    }
  },

  computed: {
    basicInfoEditConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        formData: this.formData,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            component: this.columnsContentComponent,
            title: this.$t('base/profile.basic_info'),
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'name',
                    label: this.$t('base/company.name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'address',
                    label: this.$t('base/company.address'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'postal_code',
                    label: this.$t('base/company.postal_code'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'city',
                    label: this.$t('base/company.city'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'country',
                    label: this.$t('base/company.country'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'identification_number',
                    label: this.$t('base/company.identification_number'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'type_id',
                    label: this.$t('base/company.type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'company-types'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'language_id',
                    label: this.$t('base.language'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'languages/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'trip_config_id',
                    label: this.$t('base/company.trip_config'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'trip-configs'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    showLocationsDialog (event) {
      const coords = event?.formData?.geolocation?.replace(' ', '').split(',')
      const latitude = coords?.[0] || event?.formData?.geolocation?.lat
      const longitude = coords?.[1] || event?.formData?.geolocation?.lng

      this.$set(this.chooseLocationDialogConfig, 'show', true)
      this.$set(this.chooseLocationDialogConfig, 'title', this.$t('road-maintenance.excavation_modal_location_btn'))
      this.$set(this.chooseLocationDialogConfig, 'event', event)
      if (latitude && longitude) {
        this.$set(this.chooseLocationDialogConfig, 'markers', {
          lat: latitude,
          lng: longitude
        })
      }
      this.$set(this.chooseLocationDialogConfig, 'callback', (event) => this.onLocationSaveCallback(event))
    },

    onLocationSaveCallback (event) {
      const { updateData } = event?.event || {}
      const { coordinates } = event || {}
      this.$set(this.chooseLocationDialogConfig, 'show', false)

      if (typeof updateData === 'function') {
        updateData({
          geolocation: (coordinates?.lat || null) + ', ' + (coordinates?.lng || null)
        })
      }
    }
  }
}
